import React from 'react';
import { translateBlock } from 'i18n';
import {
    Alert,
    AlertRecordValue,
    AlertRecordValueType,
} from 'lib/alert/models';
import { styled } from '@mui/material/styles';
import Flex from 'ui/Flex/Flex';
import { formatDisplay } from 'helpers/formatHelper';
import { useTranslation } from 'react-i18next';

const StyAlertValueBox = styled(Flex, { name: 'StyAlertValueBox' })(() => ({
    justifyContent: 'center',
}));

type Props = {
    recordValues: AlertRecordValue[];
    alert: Alert;
};

const FixedThresholdValueNoDimension = ({ recordValues, alert }: Props) => {
    const { t } = useTranslation();
    const value = recordValues.find(
        (v) => v.type === AlertRecordValueType.LONE_ALERT_DATA,
    );

    if (value === undefined) {
        return <div>{t('alert.status.noDataPeriod')}</div>;
    }

    const { field } = alert.metric;

    return (
        <StyAlertValueBox>
            <div
                style={{
                    textAlign: 'center',
                }}
            >
                <div>
                    <h1>
                        {formatDisplay(
                            value.value,
                            value.valueType,
                            2,
                            'default',
                        )}
                    </h1>
                </div>
                <div>
                    <h2>{translateBlock(field)}</h2>
                </div>
            </div>
        </StyAlertValueBox>
    );
};

export default FixedThresholdValueNoDimension;
